import React, { Component } from 'react'
import AsLegendColorContinuousPolygon from './airship-wrappers/AsLegendColorContinuousPolygon'
import numeral from 'numeral';
import { connect } from 'react-redux';
import { withCarto } from '../carto/withCarto';

export class DpsLegendColorContinuousPolygon extends Component {
  state = {
    data: null
  }

  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.props.CartoContext.layers[this.props.layer].on('metadataChanged', this.updateLegendData)
  }

  componentWillUnmount() {
    this.props.CartoContext.layers[this.props.layer].off('metadataChanged', this.updateLegendData)
  }

  updateLegendData = (event) => {
    let data;
    event.styles.forEach(function (styleMetadata) {
      switch(styleMetadata.getProperty()) {
        case 'marker-fill':
          data = styleMetadata.getBuckets().map(bkt => ({label: numeral(bkt.max*1000).format('0.0a'), color: bkt.value}))
          break;
        default:
          break;
      }
    });
    this.setState(state => ({
      ...state,
      data: [data[0], data[data.length-1]]
    }))
  }

  render() {
    return (
      <div style={{display: 'flex', alignItems: 'flex-end'}}>
        <AsLegendColorContinuousPolygon ref={this.ref} data={this.state.data} slot="legends" orientation="horizontal"></AsLegendColorContinuousPolygon>
        {this.state.data && <div style={lblStyle}>{this.state.data[this.state.data.length-1].label}</div>}
      </div>
    )
  }
}

let lblStyle = {
  flex: 1,
  marginLeft: -28,
  color: 'var(--as-legend-color-continuous-polygon--color)',
  font: 'var(--as--font--caption)',
  textTransform: 'capitalize',
  whiteSpace: 'nowrap',
}

const mapStateToProps = state => ({
  layers: state.carto.layers
});

export default connect(mapStateToProps)(withCarto(DpsLegendColorContinuousPolygon));
